
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAuVSECERXNCzK-xJZT7hAzY2zU0xtyDt4",
    authDomain: "trek-viajens.firebaseapp.com",
    projectId: "trek-viajens",
    storageBucket: "trek-viajens.appspot.com",
    messagingSenderId: "351685489277",
    appId: "1:351685489277:web:278ef9fb613fe50763b714",
    measurementId: "G-3R8H6RF2TR"
  };

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { auth, db, storage};